import { gql } from '@apollo/client'
import { BILTY_FIELDS, BILTY_OPS_FIELDS, DRIVER_FIELDS, JOBS_SUBSCRIPTION_FIELD, TRACKER_FIELDS, USER_FIELDS, VEHICLE_FIELDS } from './fragments'

export const CREATE_BILTY_OPS = gql`
	${BILTY_OPS_FIELDS}
	mutation CreateBiltyOp($createBiltyOpsInput: CreateBiltyOpsInput!) {
		createBiltyOp(createBiltyOpsInput: $createBiltyOpsInput) {
			...BiltyOpsFields
		}
	}
`

export const CREATE_USER = gql`
	${USER_FIELDS}
	mutation CreateUser($createUserInput: CreateUserInput!) {
		createUser(createUserInput: $createUserInput) {
			...UserFields
		}
	}
`

export const UPDATE_BILTY_OPS = gql`
	${BILTY_OPS_FIELDS}
	mutation UpdateBiltyOp($updateBiltyOpsInput: UpdateBiltyOpsInput!) {
		updateBiltyOp(updateBiltyOpsInput: $updateBiltyOpsInput) {
			...BiltyOpsFields
		}
	}
`

export const INSERT_BILTY_REGIONS = gql`
	${BILTY_OPS_FIELDS}
	mutation InsertBiltyRegions($insertRegionsInput: InsertRegionsInput) {
		insertBiltyRegions(insertRegionsInput: $insertRegionsInput) {
			...BiltyOpsFields
		}
	}
`

export const DELETE_BILTY_REGIONS = gql`
	${BILTY_OPS_FIELDS}
	mutation DeleteBiltyRegions($deleteRegionsInput: DeleteRegionsInput) {
		deleteBiltyRegions(deleteRegionsInput: $deleteRegionsInput) {
			...BiltyOpsFields
		}
	}
`

export const SWAP_USER_USERTYPE = gql`
	${USER_FIELDS}
	mutation SwapUserType($swapUserInput: SwapUserInput!) {
		swapUserType(swapUserInput: $swapUserInput) {
			...UserFields
		}
	}
`
export const UPDATE_USER_USERTYPE = gql`
	${USER_FIELDS}
	mutation UpdateUser($updateUserInput: UpdateUserInput!) {
		updateUser(updateUserInput: $updateUserInput) {
			...UserFields
		}
	}
`

export const MATCH_ORDER_TO_JOB = gql`
	${DRIVER_FIELDS}
	${BILTY_FIELDS}
	${VEHICLE_FIELDS}
	${TRACKER_FIELDS}
	mutation MatchOrderToJob($matchOrderToJobInput: MatchOrderToJobInput!) {
		matchOrderToJob(matchOrderToJobInput: $matchOrderToJobInput) {
			message
			JobId
			JobNumber
			Job {
				_id
				Tracker {
					...TrackerFields
				}
				Vehicle {
					...VehicleFields
				}
				Driver {
					...DriverFields
				}
				bilty {
					...BiltyFields
				}
			}
		}
	}
`

export const UPDATE_BILTIES = gql`
	${BILTY_FIELDS}
	mutation UpdateBilties($updateBiltiesInput: UpdateBiltiesInput!) {
		updateBilties(updateBiltiesInput: $updateBiltiesInput) {
			...BiltyFields
		}
	}
`

export const UPDATE_DRIVER = gql`
	${DRIVER_FIELDS}
	mutation UpdateDriver($updateDriverInput: UpdateDriverInput!) {
		updateDriver(updateDriverInput: $updateDriverInput) {
			...DriverFields
		}
	}
`

export const UPDATE_TRACKER = gql`
	${TRACKER_FIELDS}
	mutation UpdateTrackers($update: TrackerUpdateInput, $where: TrackerWhere) {
		updateTrackers(update: $update, where: $where) {
			trackers {
				...TrackerFields
			}
		}
	}
`

export const CREATE_TRACKER = gql`
	${TRACKER_FIELDS}
	mutation CreateTrackers($input: [TrackerCreateInput!]!) {
		createTrackers(input: $input) {
			trackers {
				...TrackerFields
			}
		}
	}
`

export const UPDATE_JOB = gql`
	${JOBS_SUBSCRIPTION_FIELD}
	mutation UpdateJob($updateJobInput: UpdateJobInput!) {
		updateJob(updateJobInput: $updateJobInput) {
			...JobSubscriptionFields
		}
	}
`

export const CREATE_STATUS = gql`
	mutation CreateStatus($createStatusInput: CreateStatusInput) {
		createStatus(createStatusInput: $createStatusInput)
	}
`
